"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _CommonContentStyleModule = _interopRequireDefault(require("../CommonContentStyle.module.scss"));

var _ClassSkillComboTooltipContentModule = _interopRequireDefault(require("./ClassSkillComboTooltipContent.module.scss"));

var _ClassSkillComboTooltipContent = _interopRequireDefault(require("./ClassSkillComboTooltipContent.i18n"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-array-index-key */
var ClassSkillComboTooltipContent = function ClassSkillComboTooltipContent(_ref) {
  var skillCombo = _ref.skillCombo,
      viewingCharacter = _ref.viewingCharacter,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage,
      locale = _useIntl.locale;

  var id = skillCombo.id,
      model = skillCombo.model;
  var modelId = model.id,
      tier = model.tier,
      classSkillModels = model.classSkillModels;
  var isEnabled = model.isEnabled; // TODO: determine if is learned instead

  var i18nName = model.i18nName;
  var lastSkillBonus = [130, 100]; // TODO

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_CommonContentStyleModule.default.content, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _CommonContentStyleModule.default.identifiers
  }, "".concat(id || "").concat(modelId && " (".concat(modelId, ")"))), /*#__PURE__*/_react.default.createElement("div", {
    className: _ClassSkillComboTooltipContentModule.default.name
  }, i18nName[locale] || i18nName.en, " (", tier, ")"), /*#__PURE__*/_react.default.createElement("div", {
    className: _ClassSkillComboTooltipContentModule.default.skills
  }, classSkillModels.map(function (skillModel, index) {
    var i18nSkillName = skillModel.i18nName;
    return /*#__PURE__*/_react.default.createElement("div", {
      key: "".concat(skillCombo.id, "_").concat(index),
      className: (0, _classnames.default)(_ClassSkillComboTooltipContentModule.default.skillEntry, !isEnabled && _ClassSkillComboTooltipContentModule.default.isUnlearned)
    }, i18nSkillName[locale] || i18nSkillName.en);
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: _ClassSkillComboTooltipContentModule.default.lastSkillBonus
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _ClassSkillComboTooltipContentModule.default.header
  }, formatMessage(_ClassSkillComboTooltipContent.default.lastSkillBonus)), lastSkillBonus.map(function (entry, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index
    }, entry, " %");
  })));
};

var _default = ClassSkillComboTooltipContent;
exports.default = _default;